import React from 'react'
import './ResumeImprovement.scss'

function ResumeImprovement() {
  const example = {
    before: 'Software Developer with extensive experience in building scalable systems, mobile applications, and developer infrastructure across various industries including e-commerce, cloud services, and enterprise software.',
    after: 'Software Developer with extensive experience in building scalable systems and developer infrastructure, including proficiency in Java and Agile methodologies, across enterprise software and e-commerce domains.',
    reason: 'I refocused the summary to better align with the job requirements. I removed "mobile applications" as it is not mentioned in the job description. I explicitly highlighted "Java" and "Agile methodologies" as these are key technologies and processes listed in the job requirements and are implied by the original "developer infrastructure" and broad experience. I reordered the industries to prioritize "enterprise software" and "e-commerce" over "cloud services" to better match the enterprise and business-system context of the role. I maintained factual accuracy by only referencing skills and experiences inferable from the original text.'
  }

  return (
    <section className="resume-improvement-section py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h2 
                className="fw-bold mb-3 resume-improvement-heading"
                style={{
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                  fontSize: '36px',
                  lineHeight: '44px',
                  letterSpacing: '-0.02em'
                }}
              >
                Your Resume, <span className="resume-improvement-accent">Perfectly Tailored</span> to Every Job
              </h2>
              <p 
                className="text-muted resume-improvement-subtitle"
                style={{
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                  fontSize: '18px',
                  lineHeight: '28px',
                  maxWidth: '700px',
                  margin: '0 auto'
                }}
              >
                Watch how our AI transforms your resume to match each job's requirements—highlighting the right skills and removing irrelevant details.
              </p>
            </div>

            <div className="resume-comparison-card">
              <div className="comparison-header">
                <div className="comparison-badge before-badge">
                  <span className="badge-icon">📝</span>
                  <span>Before</span>
                </div>
                <div className="comparison-arrow">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 7L18 12L13 17M6 7L11 12L6 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="comparison-badge after-badge">
                  <span className="badge-icon">✨</span>
                  <span>After</span>
                </div>
              </div>

              <div className="comparison-content">
                <div className="comparison-side before-side">
                  <div className="comparison-text-wrapper">
                    <p className="comparison-text">{example.before}</p>
                  </div>
                </div>

                <div className="comparison-side after-side">
                  <div className="comparison-text-wrapper">
                    <p className="comparison-text">{example.after}</p>
                  </div>
                </div>
              </div>

              <div className="improvement-reason">
                <div className="reason-header">
                  <span className="reason-icon">💡</span>
                  <h4 className="reason-title">Why We Made These Changes</h4>
                </div>
                <div className="reason-content">
                  <p>{example.reason}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ResumeImprovement


